"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripResumeOutput = void 0;
const class_validator_1 = require("class-validator");
const address_output_1 = require("../address.output");
const price_output_1 = require("../price.output");
const common_pickup_point_output_1 = require("./common-pickup-point.output");
const late_details_output_1 = require("./late-details.output");
const promo_code_output_1 = require("./promo-code.output");
const trip_history_output_1 = require("./trip-history.output");
class TripResumeOutput {
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripResumeOutput.prototype, "distance", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripResumeOutput.prototype, "duration", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripResumeOutput.prototype, "department", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripResumeOutput.prototype, "zipCode", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", address_output_1.AddressOutput)
], TripResumeOutput.prototype, "start", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", address_output_1.AddressOutput)
], TripResumeOutput.prototype, "end", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], TripResumeOutput.prototype, "steps", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripResumeOutput.prototype, "period", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripResumeOutput.prototype, "customerRemuneration", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripResumeOutput.prototype, "sellPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripResumeOutput.prototype, "initialSellPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripResumeOutput.prototype, "netBuyPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripResumeOutput.prototype, "buyPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripResumeOutput.prototype, "initialBuyPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripResumeOutput.prototype, "tollPrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", price_output_1.PriceOutput)
], TripResumeOutput.prototype, "promoCodePrice", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", promo_code_output_1.PromoCodeOutput)
], TripResumeOutput.prototype, "promoCode", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripResumeOutput.prototype, "departureAt", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripResumeOutput.prototype, "estimatedArrivalAt", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TripResumeOutput.prototype, "noShowAuthorizedAt", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", common_pickup_point_output_1.CommonPickupPointOutput)
], TripResumeOutput.prototype, "pickUpPoint", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", trip_history_output_1.TripHistoryOutput)
], TripResumeOutput.prototype, "history", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsEnum)(['PRO', 'PERSO']),
    __metadata("design:type", String)
], TripResumeOutput.prototype, "proPerso", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", late_details_output_1.LateDetails)
], TripResumeOutput.prototype, "driverLateDetails", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", late_details_output_1.LateDetails)
], TripResumeOutput.prototype, "passengerLateDetails", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripResumeOutput.prototype, "passengerCancellationReason", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripResumeOutput.prototype, "adminCancellationReason", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TripResumeOutput.prototype, "adminCancellationBy", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIn)(['INVOICED', 'TO_INVOICE']),
    __metadata("design:type", String)
], TripResumeOutput.prototype, "invoiceStatusPassenger", void 0);
exports.TripResumeOutput = TripResumeOutput;
